import React from "react";

import { QuizQuestions } from "../../const";

import Intro from "../Intro";
import Question from "./Question";
import Result from "../Result";

import { reachGoal } from "../../utils";
//
// import imageStep0 from "./images/step-0.png";
// import imageStep1 from "./images/step-1.png";
// import imageStep2 from "./images/step-2.png";
//
// import imageStep3 from "./images/step-3.png";
// import imageStep4 from "./images/step-4.png";
// import imageStep5 from "./images/step-5.png";
//
// import imageStep6 from "./images/step-6.png";
// import imageStep7 from "./images/step-7.png";
// import imageStep8 from "./images/step-8.png";

const images = [
  `${process.env.PUBLIC_URL}/images/step-0-big.png`,
  `${process.env.PUBLIC_URL}/images/step-1-big.png`,
  `${process.env.PUBLIC_URL}/images/step-2-big.png`,
  `${process.env.PUBLIC_URL}/images/step-3.png`,
  `${process.env.PUBLIC_URL}/images/step-4.png`,
  `${process.env.PUBLIC_URL}/images/step-5.png`,
  `${process.env.PUBLIC_URL}/images/step-6.png`,
  `${process.env.PUBLIC_URL}/images/step-7-big.png`,
  `${process.env.PUBLIC_URL}/images/step-8.png`,
  // imageStep0,
  // imageStep1,
  // imageStep2,
  // imageStep3,
  // imageStep4,
  // imageStep5,
  // imageStep6,
  // imageStep7,
  // imageStep8,
];

class Quiz extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      step: null,
      // step: 15,
      points: 0,
    };

    images.forEach((image) => {
      const i = new Image();
      i.src = image;
      window[image] = i;
    });

    this.handleStart = this.handleStart.bind(this);
    this.handleAnswer = this.handleAnswer.bind(this);
  }

  handleStart(event) {
    // event.stopPropagation();

    reachGoal("nachat");

    this.setState({ step: 0 });
  }

  handleAnswer(isRight) {
    if (isRight === true) {
      this.setState((prevState) => ({
        points: prevState.points + 1,
        step: prevState.step + 1,
      }));
    } else {
      this.setState((prevState) => ({
        step: prevState.step + 1,
      }));
    }
  }

  render() {
    const { step, points } = this.state;

    if (step === null) {
      return (
        <>
          <Intro onStart={this.handleStart} />
        </>
      );
    }

    if (step >= QuizQuestions.length) {
      return <Result points={points} />;
    }

    const question = QuizQuestions[step];
    return (
      <>
        <Question
          step={step}
          image={images[step]}
          stepText={`${step + 1}/${QuizQuestions.length}`}
          question={question}
          onAnswer={this.handleAnswer}
        />
      </>
    );
  }
}

export default Quiz;
